import React, { useEffect } from 'react';
import { useModal } from '~shared/components/modal-overlay/ModalContext';
import {
    onOpenFavouriteSportsModal,
} from '~spa/Utils/WrapperIntegration/Ucf';
import FavoriteSportModalWrapper from '~shared/components/favorite-sport-modal/FavoriteSportModalWrapper';
import {
    setOnboardingPageOpen,
} from '~shared/utils/user';
import {
    useOnboardingPageEnabled,
    useOnboardingPageOpen,
    useDidReceivePRDCMessage,
} from '~SpectateStore/hooks/clientStateHooks';
import {
    useIsFirstLogin,
    useIsUserLoggedIn,
} from '~SpectateStore/hooks/userHooks';
import { MODAL_TYPES } from '~shared/components/modal-overlay/constants';

const OnboardingModal = () => {
    const { pushModal, removeModalsWithId } = useModal();
    const isUserLoggedIn = useIsUserLoggedIn();
    const isOnboardingPageEnabled = useOnboardingPageEnabled();
    const isOnboardingPageOpen = useOnboardingPageOpen();
    const didReceivePRDCMessage = useDidReceivePRDCMessage();
    const isFirstLogin = useIsFirstLogin();

    const autoOpenRule = isUserLoggedIn
        && isOnboardingPageEnabled
        && isOnboardingPageOpen !== false
        && didReceivePRDCMessage
        && isFirstLogin;

    const userRequestRule = isUserLoggedIn
        && isOnboardingPageEnabled
        && isOnboardingPageOpen === true;

    const shouldOpenOnboardingPage = autoOpenRule || userRequestRule;

    useEffect(() => {
        if (shouldOpenOnboardingPage) {
            pushModal(<FavoriteSportModalWrapper />, MODAL_TYPES.ONBOARDING);
        }

        return () => removeModalsWithId(MODAL_TYPES.ONBOARDING);
    }, [shouldOpenOnboardingPage]);

    useEffect(() => {
        const unsubscribeOpenModalFn = onOpenFavouriteSportsModal(() => setOnboardingPageOpen(true));

        return () => unsubscribeOpenModalFn.unsubscribe;
    }, []);

    return <></>;
};

export default OnboardingModal;
